import { FC, ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ApiProvider } from '@trukt/react-hooks/ApiProvider';
import { UIProviders } from '@trukt/ui/UIContext';
import { UIProviders as LegacyUIProviders } from '@legacy-client-trukt/ui/UIContext';

import { msalInstance } from '@auth';
import { MsalInstanceProvider } from '@trukt/auth-web/MsalInstanceProvider';
import { ReactQueryDevtools } from 'react-query/devtools';
import { truktApi, truktTmsApi, trimbleMapsSingleSearchApi } from '@api';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 0 }, mutations: { retry: 0 } },
});

export const AppProviders: FC<Record<string, never | ReactNode>> = ({ children }) => (
  <BrowserRouter>
    <MsalInstanceProvider instance={msalInstance} apis={[truktApi, truktTmsApi]}>
      <ApiProvider truktApi={truktTmsApi} trimbleApi={trimbleMapsSingleSearchApi}>
        <UIProviders appVariant="client">
          <LegacyUIProviders appVariant="client">
            <QueryClientProvider client={queryClient}>
              {children}
              <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
          </LegacyUIProviders>
        </UIProviders>
      </ApiProvider>
    </MsalInstanceProvider>
  </BrowserRouter>
);
